import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type BudgetDraftState = {
  budget: number;
  advance: number;
  total: number;
  paymentMethod: string; // id como string del método seleccionado
};

const initialState: BudgetDraftState = {
  budget: 0,
  advance: 0,
  total: 0,
  paymentMethod: '',
};

const budgetSlice = createSlice({
  name: 'budget',
  initialState,
  reducers: {
    setBudgetDraft(state, action: PayloadAction<Partial<BudgetDraftState>>) {
      return { ...state, ...action.payload };
    },
    resetBudgetDraft() {
      return initialState;
    },
  },
});

export const { setBudgetDraft, resetBudgetDraft } = budgetSlice.actions;
export default budgetSlice.reducer;
